import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from  './modules/sidebar'
import userinfo from  './modules/userinfo'
import cominfo from  './modules/cominfo'
import meiju from  './modules/meiju'
import login from  './modules/login'
import forms from  './modules/form'
import faceSms from  './modules/faceSms'
import devinfo from "./modules/devinfo";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state:{
    userToken:'',
    downLoading:false,
  },
  modules: {
      devinfo,
    sidebar,
    userinfo,
    cominfo,
    meiju,
    login,
    faceSms,
    forms
  },
  mutations:{
    setuserToken(state,token){
      state.userToken = token;
    },
    setDownLoading(state,boolean){
      state.downLoading = boolean;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js